export default function ProgressBar({
  value,
  max,
  label,
  showPercent = true,
  colorScheme = 'default',
  size = 'md'
}) {
  const percent = max > 0 ? Math.min(100, (value / max) * 100) : 0

  const colorClasses = {
    default: 'bg-brand-600',
    success: 'bg-green-500',
    warning: 'bg-amber-500',
    danger: 'bg-red-500'
  }

  const sizeClasses = {
    sm: 'h-1.5',
    md: 'h-2.5',
    lg: 'h-4'
  }

  // Determine color based on percent if using auto
  const getAutoColor = () => {
    if (percent >= 100) return 'success'
    if (percent >= 80) return 'default'
    if (percent >= 50) return 'warning'
    return 'danger'
  }

  const finalColor = colorScheme === 'auto' ? getAutoColor() : colorScheme

  return (
    <div>
      {label && (
        <div className="flex items-center justify-between mb-1">
          <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
            {label}
          </span>
          {showPercent && (
            <span className="text-sm font-medium text-gray-500 dark:text-gray-400">
              {percent.toFixed(1)}%
            </span>
          )}
        </div>
      )}
      <div className={`w-full bg-gray-200 dark:bg-gray-700 rounded-full ${sizeClasses[size]}`}>
        <div
          className={`${colorClasses[finalColor]} ${sizeClasses[size]} rounded-full transition-all duration-500`}
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  )
}
